import React, { RefObject } from "react";

export type ScrollerContextValue = {
  scrollLeft: number;
  hasItemOverflow: boolean;
  isAtStart: boolean;
  isAtEnd: boolean;
  fullPageStretch?: boolean;
  fullWidthItemsFinal?: boolean;
  sideHeader?: boolean;
  scrollingElRef: RefObject<HTMLOListElement>;
  gotoNext: () => void;
  gotoPrev: () => void;
};

const ScrollerContext = React.createContext<ScrollerContextValue>({
  scrollLeft: 0,
  hasItemOverflow: false,
  isAtStart: true,
  isAtEnd: false,
  fullPageStretch: false,
  fullWidthItemsFinal: false,
  sideHeader: false,
  scrollingElRef: { current: null },
  gotoNext: () => {},
  gotoPrev: () => {},
});

export default ScrollerContext;
